import { fetchData, apiURL } from "./api_helper";

//  USER CRUD

//  CREATE
const createMovement = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/movements`;
    fetchData(endpointURL, "post", data)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  READ
const readMovementsByBoxId = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/movements/${data.boxID}?page=${data.page}`;
    fetchData(endpointURL, "get")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

const readMovements = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/movements`;
    fetchData(endpointURL, "get", data)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  UPDATE
const updateMovement = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/movements/${data.id}`;
    fetchData(endpointURL, "PATCH", data.body)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

//  DELETE
const deleteMovement = data =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/movements/${data.id}`;
    fetchData(endpointURL, "delete")
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });

export default {
  createMovement,
  readMovementsByBoxId,
  readMovements,
  updateMovement,
  deleteMovement
};
